// Cart Validation - Prevent checkout with only add-ons
// Shows error message if cart contains ONLY add-on items

(function() {
  'use strict';

  console.log('Cart validation initialized');

  // Check cart when page loads and when checkout button is clicked
  function validateCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.items.length === 0) {
          return; // Empty cart is fine
        }

        // Check if ALL items are add-ons
        const hasMainProduct = cart.items.some(item => {
          // An item is a main product if it does NOT have the _Add-On property
          return !(item.properties && item.properties['_Add-On']);
        });

        if (!hasMainProduct) {
          // Cart has ONLY add-ons - show error and disable checkout
          showAddOnOnlyError();
          disableCheckoutButtons();
        } else {
          // Cart is valid - enable checkout
          hideAddOnOnlyError();
          enableCheckoutButtons();
        }
      })
      .catch(error => {
        console.error('Error validating cart:', error);
      });
  }

  function showAddOnOnlyError() {
    // Check if error already exists
    let errorDiv = document.getElementById('addon-only-error');
    
    if (!errorDiv) {
      // Create error message
      errorDiv = document.createElement('div');
      errorDiv.id = 'addon-only-error';
      errorDiv.style.cssText = `
        background-color: #fee;
        border: 2px solid #c33;
        color: #c33;
        padding: 15px;
        margin: 15px 0;
        border-radius: 4px;
        font-weight: bold;
        text-align: center;
      `;
      errorDiv.innerHTML = '⚠️ Add-on items must be purchased with a main product. Please add a product to your cart.';
      
      // Insert at top of cart
      const cartForm = document.querySelector('form[action="/cart"]') || 
                      document.querySelector('[data-cart-form]') ||
                      document.querySelector('.cart');
      
      if (cartForm) {
        cartForm.insertBefore(errorDiv, cartForm.firstChild);
      }
    }
    
    errorDiv.style.display = 'block';
  }

  function hideAddOnOnlyError() {
    const errorDiv = document.getElementById('addon-only-error');
    if (errorDiv) {
      errorDiv.style.display = 'none';
    }
  }

  function disableCheckoutButtons() {
    const checkoutButtons = document.querySelectorAll(
      'button[name="checkout"], ' +
      'input[name="checkout"], ' +
      '[href*="/checkout"], ' +
      '.cart__checkout, ' +
      '.cart-checkout-button'
    );
    
    checkoutButtons.forEach(button => {
      button.disabled = true;
      button.style.opacity = '0.5';
      button.style.cursor = 'not-allowed';
      
      // Prevent clicks
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        alert('Please add a main product to your cart before checking out.');
        return false;
      }, true);
    });
  }

  function enableCheckoutButtons() {
    const checkoutButtons = document.querySelectorAll(
      'button[name="checkout"], ' +
      'input[name="checkout"], ' +
      '[href*="/checkout"], ' +
      '.cart__checkout, ' +
      '.cart-checkout-button'
    );
    
    checkoutButtons.forEach(button => {
      button.disabled = false;
      button.style.opacity = '1';
      button.style.cursor = 'pointer';
    });
  }

  // Run validation when page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', validateCart);
  } else {
    validateCart();
  }

  // Re-validate periodically in case cart changes
  setInterval(validateCart, 2000);

})();